// ============================================================
// api/adminAnalytics.js
// Platform Analytics endpoints — internal A2Z IT tooling.
// ============================================================

import { apiGet } from './client';

export const getAnalyticsOverview            = ()                  => apiGet('/mgmt/admin/analytics/overview');
export const getAnalyticsAgentVolumes        = (months = 3)        => apiGet('/mgmt/admin/analytics/agent-volumes', { months });
export const getAnalyticsNotificationVolumes = (months = 3)        => apiGet('/mgmt/admin/analytics/notification-volumes', { months });
export const getAnalyticsNarrativeRefreshes  = (limit = 50)        => apiGet('/mgmt/admin/analytics/narrative-refreshes', { limit });
